import { gql } from "@apollo/client";

export const updateCompanyPolicy = gql`
  mutation updateCompanyPolicy($_id: MongoID!, $record: UpdateByIdCompanyPolicyInput!) {
    companyPolicy_UpdateById(_id: $_id, record: $record) {
      record {
        _id
      }
    }
  }
`;